import React, { useState } from "react";
import { Grid2 } from "@mui/material";
import styles from "./ManualMigration.module.scss";
import ExpandableRow from "../../../../../../../../GlobalComponents/ExpandableRow/ExpandableRow";
// images
import { ReactComponent as ExportDb } from "../../../../../../AdminAssets/svg/export_db.svg";
import { ReactComponent as DropTable } from "../../../../../../AdminAssets/svg/drop_table.svg";
import { ReactComponent as BrowseDb } from "../../../../../../AdminAssets/svg/browse_db.svg";
import { ReactComponent as TablesDb } from "../../../../../../AdminAssets/svg/tables_db.svg";
import { ReactComponent as WpOptions } from "../../../../../../AdminAssets/svg/wp_options.svg";

const ManualMigration = (props) => {
  const { siteName } = props;
  const [expandedRow, setExpandedRow] = useState("1");

  return (
    <Grid2 className={styles.manualMigrationContainer}>
      <ExpandableRow
        sno="1"
        header="Export database from your prior hosting provider"
        subHeader="The export file contains instructions for our server's database language (SQL) to create the posts, comments and options from your old host on our host. The database export file contains SQL instructions to duplicate all posts, comments, and settings (at the time of export) on Rocon's servers."
        steps={[
          {
            subSteps: [
              {
                text: "Log in to your current provider's cPanel and access phpMyAdmin.",
              },
              {
                text: "On the left-hand side, select the site database you wish to migrate. Click the Export button on the top navigation bar.",
              },
              {
                text: "Under Export Method, select Custom. Under Table(s), click Select all.",
              },
              {
                text: "Under Object creation options, make sure the following options are checked. Scroll down to the bottom of the page and click Go to save the database to your desktop.",
              },
            ],
            image: <ExportDb />,
          },
        ]}
        expandedRow={expandedRow}
        setExpandedRow={setExpandedRow}
      />
      <ExpandableRow
        sno="2"
        header="Download your WP-Content Folder"
        subHeader="The wp-content folder contains your plugins, themes and media. Depending on how big your site is, this can take a while sometimes up to a couple of hours."
        steps={[
          {
            subSteps: [
              {
                text: "Log into your current host via their portal or FTP client.",
              },
              { text: "Access wp-content." },
              {
                text: "Download/copy the wp-content folder to your computer's desktop.",
              },
            ],
          },
        ]}
        expandedRow={expandedRow}
        setExpandedRow={setExpandedRow}
      />
      <ExpandableRow
        sno="3"
        header="Import your database to Rocon"
        subHeader="The database export file contains SQL instructions to duplicate all posts, comments, and settings (at the time of export) on Rocon's servers. Clear your default WordPress database, then import your new database to Rocon. If you have a large database, please request expert migration."
        steps={[
          {
            subSteps: [
              {
                text: "Access your environment's phpMyAdmin and click on the database on the far left titled as your sitename",
              },
              {
                text: "Halfway down the page, select Check All and Drop from the dropdown menu. Select Yes to confirm",
                image: <DropTable />,
              },
              {
                text: " Once this completes, click the Import tab at the top and select Choose File/Browse. Select the database file you would like to import and click Go at the bottom of the page.",
                image: <BrowseDb />,
              },
              {
                text: `Once you have successfully imported your database, check your table prefixes. If they do not start with "wp_".`,
                image: <TablesDb />,
              },
              {
                text: "In wp_options table, make sure you edit option_value of siteurl and home to your temporary domain . as we are migrating your site to a temp domain in Rocon.",
                image: <WpOptions />,
              },
            ],
          },
        ]}
        expandedRow={expandedRow}
        setExpandedRow={setExpandedRow}
      />
      <ExpandableRow
        sno="4"
        header="Import your wp-content.zip files to Rocon"
        steps={[
          {
            subTitle: (
              <>
                Upload the wp-content directory as a .zip to Rocon. This is the
                content you previously downloaded from your prior host. When the
                file is uploaded, your site should now be live on the temporary
                domain <strong>{siteName}</strong>.
                <strong>{process.env.REACT_APP_TEMP_DOMAIN}</strong>
              </>
            ),
          },

          {
            subTitle: `Before migrating, make sure that your current site's WP version
                is aligned with the one you created in Rocon to avoid
                incompatibility issues. It is suggested to update your WP
                version if it is outdated since new sites created in Rocon use
                the latest stable version. In case of any issues, you can
                contact support.`,
          },
          {
            subTitle:
              " You can use one of the following methods to import your wp-content file.",
          },
          {
            subSteps: [
              {
                text: "Before migrating make sure. that your current sites wp-version is aligned with that of the site you have created in rocon to avoid incompatability issues. it is suggested to update your wp version if its not updated. since new site created in rocon are in the latest stable version. in case of any issues you can contact support .",
              },
              {
                text: "Navigate to the public_html directory.",
              },
              {
                text: "Upload the wp-content folder you downloaded from your current host.",
              },
            ],
          },
        ]}
        expandedRow={expandedRow}
        setExpandedRow={setExpandedRow}
      />
      <ExpandableRow
        sno="5"
        header="Go Live!"
        steps={[
          {
            subTitle: (
              <>
                Once your site is live on the temporary domain{" "}
                <strong>
                  {siteName}.{process.env.REACT_APP_TEMP_DOMAIN}
                </strong>{" "}
                and you have tested the functionality, you can point your main
                domain. Head to "Point Your Domain" for detailed information on
                how to go live. In case of any issues faced in earlier steps,
                you can reach out to support.
                <br />
                <br />
                <strong>Note:</strong> This step isn’t relevant if you do not
                have a custom domain.
              </>
            ),
          },
        ]}
        expandedRow={expandedRow}
        setExpandedRow={setExpandedRow}
      />
    </Grid2>
  );
};

export default ManualMigration;
